import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-spoe-simple-error-dialog',
  templateUrl: './spoe-simple-error-dialog.component.html',
  styleUrls: ['./spoe-simple-error-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpoeSimpleErrorDialogComponent {
  data = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<SpoeSimpleErrorDialogComponent>);

  constructor() {
    this.dialogRef.disableClose = false;
  }
}
